const bgCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Име на файла...",
    description: "Placeholder for file name input",
  },
};

export default bgCreateFile;
